import PollCheckbox from 'components/PollOptions/PollCheckbox';
import PollRadio from 'components/PollOptions/PollRadio';
import PollStarRate from 'components/PollOptions/PollStarRate';
import PollTextarea from 'components/PollOptions/PollTextarea';
import { CloseIcon } from 'components/icons/CloseIcon';

interface IPollDisplay {
  onCancel: () => void;
  poll: any;
}

export default function PollDisplay({ onCancel, poll }: IPollDisplay) {
  const renderQuestion = (question: any, questionNum: number) => {
    if (question.type === 'multiple') {
      return (
        <div key={question.id} className="py-4">
          <p className="my-2 font-bold">
            {question.name} &nbsp;{question.answer_required ? '*' : ''}
          </p>
          <div className="flex flex-col gap-2">
            {question.answers.map((option: any, index: number) => (
              <PollCheckbox
                option={option}
                handleMultipleChoiceChange={() => console.log('')}
                key={index}
                questionNum={questionNum}
                responses={{}}
                answerNum={0}
              />
            ))}
          </div>
        </div>
      );
    } else if (question.type === 'single') {
      return (
        <div key={question.id} className="py-4">
          <p className="my-2 font-bold">
            {question.name} &nbsp;{question.answer_required ? '*' : ''}
          </p>
          <div className="flex flex-col gap-2">
            {question.answers.map((option: any, index: number) => (
              <PollRadio
                name={question.name}
                option={option}
                handleSingleChoiceChange={() => console.log('')}
                key={index}
                questionNum={questionNum}
                responses={{}}
              />
            ))}
          </div>
        </div>
      );
    } else if (question.type === 'short_answer') {
      return (
        <div key={question.id} className="py-4">
          <p className="my-2 font-bold">
            {question.name} &nbsp;{question.answer_required ? '*' : ''}
          </p>
          <PollTextarea handleTextResponseChange={() => console.log('')} questionNum={questionNum} responses={{}} />
        </div>
      );
    } else if (question.type === 'rating_scale') {
      return (
        <div key={question.id} className="py-4">
          <p className="my-2 font-bold">
            {question.name} &nbsp;{question.answer_required ? '*' : ''}
          </p>
          <PollStarRate handleRateChange={() => console.log('')} questionNum={questionNum} responses={{}} />
        </div>
      );
    }
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300  bg-white py-9 px-7 w-screen md:w-[500px] md:min-h-[300px] rounded-lg">
        <div className="flex">
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
        </div>
        <div className="flex">
          {poll?.poll_type === 'external_poll' ? (
            <iframe src={poll?.external_poll} width="100%" style={{ minHeight: 560, height: 'auto' }}></iframe>
          ) : (
            <div className="flex-1">
              {(poll?.questions || []).map((question: any, idx: number) => renderQuestion(question, idx))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
